import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import { PGetAllAnonymeRecapBudgetAsync } from '@/api/ligneCommande';
import { PGetAllFaceByLigneCommandeAnonymeAsync } from '@/api/produitFace';
import { PGetAllAnonymeWithLiensInferieursAsync, PGetAllAnonymeAsync } from '@/api/tiers';
import { browseDepartements } from '@/api/geoGouvFr';
import getDetailProduits from '@/services/gestionTiers/produit';
import getPdv, { getPdvByTiersAllData } from '@/services/gestionTiers/getPdv';
import { getCouleurCategorie } from '@/services/general/general';
import { limitTiers, gestionLogoTiers, formatTiersGroupe } from '@/services/gestionTiers/formatTiers';
import { RAYON_DEFAULT } from '@/configurations/configurationCarto';
import * as config from '@/configurations/clientConf';
import formatageConcurrents from '@/services/concurrent/concurrent';
import * as allTypes from '../mutation-type';
import * as types from './dataTiers-mutation-type';

function initialState() {
  return {
    panneauxClient: [],
    client: {},
    filterInPdv: false,
    filterInEnseigne: false,
    dataTiersFilter: [],
    lignesCommandes: [],
    currFilter: '',
    filter: {
      pdv: [],
      enseigne: [],
      departement: [],
      ville: [],
    },
    tiersAll: [],
    tiersAllInit: [],
    tiersAllForHash: [],
    produitsFaceCarto: [],
    montantBudgetTotal: 0,
    departements: [],
    rayon: RAYON_DEFAULT,
    concurrents: [],
    nbreConcurrents: 0,
    societe: {},
  };
}
function getCouleur(data) {
  if (!data) return '';
  let libelle = data.libelle;
  if (data.produitEnfant) libelle = data.produitEnfant.libelle;
  const couleur = getCouleurCategorie(libelle.replace('Location', '').trim());
  return couleur;
}
const state = initialState();

const namespaced = true;

const mutations = {
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach((key) => {
      state[key] = s[key];
    });
  },
  [allTypes.RESET_NOT_PERSISTED](state) {
    const s = initialState();
    Object.keys(state).forEach((key) => {
      state[key] = s[key];
    });
  },
  [types.SET_PANNEAUX_CLIENT](state, panneauxClient) {
    state.panneauxClient = panneauxClient;
  },
  [types.SET_CLIENT](state, client) {
    state.client = client;
  },
  [types.SET_FILTER_IN_PDV](state, val) {
    state.filterInPdv = val;
  },
  [types.SET_FILTER_IN_ENSEIGNE](state, val) {
    state.filterInEnseigne = val;
  },
  [types.SET_DATA_TIERS_FILTER](state, val) {
    state.dataTiersFilter = val;
  },
  [types.SET_CURR_FILTER](state, val) {
    state.currFilter = val;
  },
  [types.SET_VALUE_PROPRIETY_FILTER](state, payload) {
    state.filter[payload.propriety] = payload.value;
  },
  [types.SET_TIERS_ALL](state, val) {
    state.tiersAll = val;
  },
  [types.SET_TIERS_ALL_INIT](state, val) {
    state.tiersAllInit = val;
  },
  [types.SET_TIERS_ALL_FOR_HASH](state, val) {
    state.tiersAllForHash = val;
  },
  [types.SET_PRODUITS_CARTO](state, val) {
    state.produitsFaceCarto = val;
  },
  [types.SET_MONTANT_TOTAL](state, val) {
    state.montantBudgetTotal = val;
  },
  [types.SET_DEPARTEMENTS](state, val) {
    state.departements = val;
  },
  [types.SET_CONCURRENTS](state, concurrents) {
    state.concurrents = concurrents;
  },
  [types.SET_FILTER_RAYON](state, rayon) {
    state.rayon = rayon;
  },
  [types.SET_NBRE_CONCURRENTS](state, nbreConcurrents) {
    state.nbreConcurrents = nbreConcurrents;
  },
  [types.SET_SOCIETE](state, societe) {
    state.societe = societe;
  },
};

const actions = {
  getDataFilter({ getters }, payload) {
    let data = [];
    let labelModal = '';
    if (payload.type === 'pdv') {
      labelModal = 'Rechercher par points de vente';
      const pdv = getPdv(getters);
      data = pdv.map(tiers => ({
        label: tiers.nomCommercial,
        value: tiers.id,
        tiersParentId: tiers.tiersParentId,
      }));
    }
    if (payload.type === 'enseigne') {
      labelModal = 'Rechercher par enseignes';
      const enseignes = [];
      getters.tiersAllInit.forEach(tiers1 => {
        if (tiers1.typologie === 'Enseigne') {
          enseignes.push(tiers1);
        }
        tiers1.tiersEnfants.forEach(tiers2 => {
          if (tiers2.typologie === 'Enseigne') {
            enseignes.push(tiers2);
          }
        });
      });
      data = enseignes.map(tiers => ({
        label: tiers.nomCommercial,
        value: tiers.id,
      }));
    }
    if (payload.type === 'departement' || payload.type === 'ville') {
      labelModal = 'Rechercher par départements';
      const pdv = getPdv(getters);
      const codesPostal = pdv.map(p => p.adressePostale.codePostal)
        .filter(code => !!code && code.length);
      data = getters.departements.filter(dep => {
        return codesPostal
          .some(item => {
            const regex = new RegExp(`^${dep.value}`);
            return regex.test(item);
          });
      });
    }
    if (payload.type === 'ville') {
      labelModal = 'Rechercher par villes';
      const pdv = getPdv(getters);
      data = [];
      pdv.forEach(el => {
        if (el.adressePostale
            && el.adressePostale.ville
            && !data.map(item => item.value).includes(el.adressePostale.ville)) {
          data.push({
            label: el.adressePostale.ville,
            value: el.adressePostale.ville,
          });
        }
      });
    }
    data.sort((a, b) => {
      if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
      if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
      return 0;
    });
    return {
      data,
      labelModal,
    };
  },
  getProduitsFaceForCarto: async ({ commit, rootGetters, getters }) => {
    const payload = {};
    if (getters.filter.enseigne.length) {
      payload.enseigneIds = getters.filter.enseigne.map(el => el.value);
    }
    if (getters.filter.pdv.length) {
      payload.pointDeVenteIds = getters.filter.pdv.map(el => el.value);
    }
    if (getters.filter.departement.length) {
      payload.depts = getters.filter.departement.map(el => el.value);
    }
    if (getters.filter.ville.length) {
      payload.villes = getters.filter.ville.map(el => el.value);
    }
    if (rootGetters['user/tiersId'].length) {
      payload.tiersId = rootGetters['user/tiersId'];
    }
    payload.dateLigneAA = moment().format('YYYY-MM-DD');
    const results = (await PGetAllFaceByLigneCommandeAnonymeAsync(rootGetters['user/hash'], payload)).data.result.items;
    const produitsFaces = results.map(produit => {
      const location = produit.liaisonsTarif.find(el => el.libelle.includes('Location')
        || el.produitEnfant.supportCommercial.libelle.includes('Location'));
      return {
        coordonnees: {
          lat: produit.produitFace.adresse.latitude
            ? produit.produitFace.adresse.latitude
            : 0,
          lng: produit.produitFace.adresse.longitude
            ? produit.produitFace.adresse.longitude
            : 0,
        },
        id: produit.id,
        azimut: produit.produitFace.azimut ? produit.produitFace.azimut : 0,
        couleur: getCouleur(location),
      };
    });
    commit('SET_PRODUITS_CARTO', produitsFaces);
  },
  getAllTiers: async ({ commit, rootGetters, getters }) => {
    const payload = {
      sousType: ['Aucun'],
      type: 'Client',
    };
    if (getters.filter.enseigne.length) {
      payload.enseigneIds = getters.filter.enseigne.map(el => el.value);
    }
    if (getters.filter.pdv.length) {
      payload.pointDeVenteIds = getters.filter.pdv.map(el => el.value);
    }
    if (getters.filter.departement.length) {
      payload.depts = getters.filter.departement.map(el => el.value);
    }
    if (getters.filter.ville.length) {
      payload.villes = getters.filter.ville.map(el => el.value);
    }
    const response = (await PGetAllAnonymeWithLiensInferieursAsync(rootGetters['user/hash'], payload)).data.result.items;
    commit('SET_TIERS_ALL_FOR_HASH', cloneDeep(response));
    if (rootGetters['user/tiersId'].length) {
      limitTiers(response, rootGetters['user/tiersId']);
    }
    gestionLogoTiers(response);
    const groupes = response.filter(el => el.typologie === 'Groupe');
    const enseignes = response.filter(el => el.typologie === 'Enseigne');
    const pdvs = response.filter(el => el.typologie === 'PointVente');
    const aucuns = response.filter(el => el.typologie === 'Aucun');
    let resultTiers = [];
    if (groupes.length) resultTiers = formatTiersGroupe(groupes);
    if (!groupes.length && enseignes.length) resultTiers = enseignes;
    if (!groupes.length && !enseignes.length && pdvs.length) resultTiers = pdvs;
    if (!groupes.length && !enseignes.length && !pdvs.length) resultTiers = aucuns;
    commit('SET_TIERS_ALL', resultTiers);
  },
  getAllTiersInit: async ({ commit, rootGetters }) => {
    const response = (await PGetAllAnonymeWithLiensInferieursAsync(rootGetters['user/hash'], {
      type: 'Client',
      sousType: ['Aucun'],
    })).data.result.items;
    if (rootGetters['user/tiersId'].length) {
      limitTiers(response, rootGetters['user/tiersId']);
    }
    gestionLogoTiers(response);
    const groupes = response.filter(el => el.typologie === 'Groupe');
    const enseignes = response.filter(el => el.typologie === 'Enseigne');
    const pdvs = response.filter(el => el.typologie === 'PointVente');
    const aucuns = response.filter(el => el.typologie === 'Aucun');
    let resultTiers = [];
    if (groupes.length) {
      resultTiers = groupes;
      commit('SET_FILTER_IN_ENSEIGNE', true);
      commit('SET_FILTER_IN_PDV', true);
    }
    if (!groupes.length && enseignes.length) {
      resultTiers = enseignes;
      commit('SET_FILTER_IN_ENSEIGNE', true);
      commit('SET_FILTER_IN_PDV', true);
    }
    if (!groupes.length && !enseignes.length && pdvs.length) {
      resultTiers = pdvs;
      commit('SET_FILTER_IN_PDV', true);
    }
    if (!groupes.length && !enseignes.length && !pdvs.length) {
      resultTiers = aucuns;
    }
    commit('SET_TIERS_ALL_INIT', resultTiers);
    commit('SET_SOCIETE', resultTiers[0].societe);
  },
  getMontantTotalBudget: async ({ commit, rootGetters, getters }, payload) => {
    if (rootGetters['user/tiersId'].length) {
      payload.tiersId = rootGetters['user/tiersId'];
    }
    if (getters.filter.enseigne.length) {
      payload.enseigneIds = getters.filter.enseigne.map(el => el.value);
    }
    if (getters.filter.pdv.length) {
      payload.pointDeVenteIds = getters.filter.pdv.map(el => el.value);
    }
    if (getters.filter.departement.length) {
      payload.depts = getters.filter.departement.map(el => el.value);
    }
    if (getters.filter.ville.length) {
      payload.villes = getters.filter.ville.map(el => el.value);
    }
    const montant = (await PGetAllAnonymeRecapBudgetAsync(rootGetters['user/hash'], payload)).data.result;
    commit('SET_MONTANT_TOTAL', montant);
  },
  getLignesCmdesForPdv: async ({ rootGetters, commit }, payload) => {
    // actuellement cet appel nous renvoie avec l'hierachie (groupe-enseigne-pdv)
    // qui nous est utile dans d'autres ecrans
    // ce qui justifie ceci data.result.items[0].tiersEnfants[0].tiersEnfants[0]
    // même si c'est relou
    let resPdv = {};
    if (payload.type === 'Aucun') {
      resPdv = (await PGetAllAnonymeWithLiensInferieursAsync(rootGetters['user/hash'], {
        sousType: [config.SOUS_TYPE_AUCUN],
        type: config.TYPE_CLIENT,
      })).data.result.items[0];
    } else {
      const response = (await PGetAllAnonymeWithLiensInferieursAsync(rootGetters['user/hash'], {
        tiersId: payload.id,
        sousType: [config.SOUS_TYPE_AUCUN],
        type: config.TYPE_CLIENT,
      })).data.result.items;

      gestionLogoTiers(response);
      resPdv = response[0].tiersEnfants[0].tiersEnfants[0];
    }
    const dateLigneAA = moment().format('YYYY-MM-DD');
    const results = (await PGetAllFaceByLigneCommandeAnonymeAsync(rootGetters['user/hash'], {
      tiersId: payload.id,
      dateLigneAA,
    })).data.result.items;

    let panneaux = [];
    if (results.length) {
      panneaux = await getDetailProduits(
        results.map(el => el.id),
        dateLigneAA,
        rootGetters['user/hash'],
      );
    }
    for (let index = 0; index < panneaux.length; index += 1) {
      const element = panneaux[index];
      if (element.echeanciers && element.echeanciers.some(ech => ech.isEcheancierFictif)) {
        element.isEcheancierFictif = true;
      } else {
        element.isEcheancierFictif = false;
      }
      if (element.echeanciers && element.echeanciers.some(ech => ech.isNonRenouvelee)) {
        element.isNonRenouvelee = true;
      } else if (element.isNonRenouvelee !== true) {
        element.isNonRenouvelee = false;
      }
    }
    commit('SET_PANNEAUX_CLIENT', panneaux);
    commit('SET_CLIENT', resPdv);
  },
  getDepartements: ({ commit }) => {
    return new Promise((resolve, reject) => {
      browseDepartements().then((response) => {
        const result = response.data.map(dep => {
          return {
            value: dep.code,
            label: dep.nom,
          };
        });
        commit(types.SET_DEPARTEMENTS, result);
        resolve();
      }).catch((e) => {
        reject(e.code);
      });
    });
  },
  recupererConcurrents: async ({ rootGetters, getters, commit }) => {
    const query = {
      typologie: [config.POINT_VENTE],
      type: config.TYPE_CLIENT,
      sousType: [config.SOUS_TYPE_CONCURRENT],
      coordonnees: {
        longitude: getters.client.adressePostale.longitude,
        latitude: getters.client.adressePostale.latitude,
        rayon: getters.rayon,
      },
      archive: false,
    };
    // eslint-disable-next-line no-useless-catch
    try {
      const pdvs = (await PGetAllAnonymeAsync(rootGetters['user/hash'], query)).data.result.items;
      const data = formatageConcurrents(pdvs, getters.client.secteurActiviteId);
      let nbreReelConcurrent = 0;
      data.forEach(el => {
        el.children.forEach(child => {
          if (child.children.length) nbreReelConcurrent += child.children.length;
          else nbreReelConcurrent += 1;
        });
      });
      commit(types.SET_CONCURRENTS, data);
      commit(types.SET_NBRE_CONCURRENTS, nbreReelConcurrent);
    } catch (error) {
      throw error;
    }
  },
};

const getters = {
  produits: (state) => state.produits,
  panneauxClient: (state) => state.panneauxClient,
  client: (state) => state.client,
  filterInPdv: (state) => state.filterInPdv,
  filterInEnseigne: (state) => state.filterInEnseigne,
  dataTiersFilter: (state) => state.dataTiersFilter,
  currFilter: (state) => state.currFilter,
  filter: (state) => state.filter,
  pdvsFilter: (state) => getPdvByTiersAllData(state.tiersAll),
  pdvsInit: (state) => getPdvByTiersAllData(state.tiersAllInit),
  produitsFilter: (state, getters) => {
    const tiersId = getters.pdvsFilter.map(el => el.id);
    return state.produits
      .filter(produit => produit.tiersId
        .some(el => tiersId.includes(el)) && produit.produitPatrimoine);
  },
  tiersAll: (state) => state.tiersAll,
  tiersAllInit: (state) => state.tiersAllInit,
  tiersAllForHash: (state) => state.tiersAllForHash,
  produitsFaceCarto: (state) => state.produitsFaceCarto,
  montantBudgetTotal: (state) => state.montantBudgetTotal,
  departements: (state) => state.departements,
  rayon: (state) => {
    return state.rayon;
  },
  concurrents: (state) => {
    return state.concurrents;
  },
  pdvConcurrentSelected: (state) => {
    const marques = state.concurrents
      .map(c => c.children).flat();
    const pdvs = marques
      .map(c => c.children).flat();
    return [
      ...pdvs,
      ...marques.filter(e => e.isPdv),
    ].filter(c => c.selected);
  },
  nbreConcurrents: (state) => {
    return state.nbreConcurrents;
  },
  societe: (state) => {
    return state.societe;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
